import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/check.svg";

const AlternativeCheck = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default AlternativeCheck;
